import { useTranslation } from 'react-i18next'

interface Props {
  onGetPlan: () => void
  timeLeft: string
}

export default function PaywallTimerBar({ onGetPlan, timeLeft }: Props) {
  const { t } = useTranslation()

  return (
    <div className="border-hw-line animate-fade-in sticky top-0 z-30 border-b bg-white/95 backdrop-blur">
      <div className="hw-container flex items-center justify-between gap-3 py-3">
        <div>
          <p className="text-hw-muted text-xs font-medium">
            {t('pages.checkout.plans.discount_reserved')}
          </p>

          <p className="text-hw-red text-2xl font-bold tabular-nums">
            {timeLeft}
          </p>
        </div>

        <button
          className="bg-hw-primary hover:bg-hw-primary-dark animate-pulse-cta rounded-full px-5 py-3 text-sm font-bold text-white transition-colors"
          onClick={onGetPlan}
          type="button"
        >
          {t('pages.checkout.v1.getMyPlan')}
        </button>
      </div>
    </div>
  )
}
